import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReceiptCancellationService } from '../receipt-cancellation.service';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-receipt-cancellation-dialog',
  templateUrl: './receipt-cancellation-dialog.component.html',
  styleUrls: ['./receipt-cancellation-dialog.component.scss']
})
export class ReceiptCancellationDialogComponent implements OnInit {
  payment!: FormGroup;
  paymode: any;
  payamount: any;
  constructor(public dialogRef: MatDialogRef<ReceiptCancellationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private service :ReceiptCancellationService ,private fb:FormBuilder,private toast:ToastmessageService ){

  }
  ngOnInit(): void {
    console.log('payment', this.data)
    this.payment = this.fb.group({
      anyOtherReasons: ["", Validators.required],

    })
    // this.adm=this.data.admNo
    this.amount()
  }
 amount(){
 this.service.paymentrecepit(this.data.admNo,this.data.encryptedReceiptNo).subscribe(res =>{
 this. payamount=res
 })
 }
 getTotalAmount(): number {
  return this.payamount?.reduce((total:any, item:any) => total + item.amount, 0);
}
approval(data:any){
  let data2 = {
      "admNo":this.data.admNo,
       "employeeId":this.data.employeeId,
        "campusId":this.data.campusId,
         "encReciptNumber":this.data.encryptedReceiptNo,
          "approvalStatus":"APPROVED",
          "approvalRemarks":this.payment.value.anyOtherReasons.length<=0 ? null : this.payment.value.anyOtherReasons,
  }
 
  // if (confirm('do you want to approve Course Track Details')) {
  //   this.service.paymentreject( data2).subscribe((res: any) => {
  //     next: (res: any) => {
  //     console.log("updated data");
  //     this.dialogRef.close("DATA");
  //   },
  //   error: (error: any) => {
  //     if (error.status === 422) {
  //       // Show a warning message if the status is 422
  //       this.toast.showWarning("Student will be transferred");
  //     } 
  //   }
  //   })
  // }
  if (confirm('Do you want to approve Receipt Cancallation?')) { 
    this.service.paymentreject(data2).subscribe({
      next: (res: any) => {
        this.dialogRef.close("DATA");
        this.toast.showSuccess("Student Receipt Cancallation Approve successfull");
      },
      error: (error: any) => {
        const statusCode = error.status || error.error?.status || error.response?.status;
        if (statusCode === 422) {
          this.toast.showWarning("Student On Going  transferred");
        } 
      }
    });
  } else {
    this.toast.showInfo("Action canceled");
  }
  
}
reject(data:any){ 
  let data2 = {
    "admNo":this.data.admNo,
     "employeeId":this.data.employeeId,
      "campusId":this.data.campusId,
       "encReciptNumber":this.data.encryptedReceiptNo,
        "approvalStatus":"REJECTED",
        "approvalRemarks":this.payment.value.anyOtherReasons.length<=0 ? null : this.payment.value.anyOtherReasons,
}
 
if (confirm('Do you want to approve Course Track Details?')) {
  this.service.paymentreject(data2).subscribe({
    next: (res: any) => {
      this.dialogRef.close("DATA");
      this.toast.showSuccess("Student Receipt Cancallation REJECTED will be successfull");
    },
    error: (error: any) => {
      const statusCode = error.status || error.error?.status || error.response?.status;
      if (statusCode === 422) {
        this.toast.showWarning("Student will be transferred");
      } 
    }
  });
} else {
  this.toast.showInfo("Action canceled");
}
}
}
